import { useCallback, useContext } from 'react'
import { WarehousesTableContext } from '../context'
import { useSelection } from '@shared/modules/next-table/hooks/use-selection'
import { useBackgroundNavigate } from '@shared/hooks'

export const useWarehousesTableActions = () => {
  const navigate = useBackgroundNavigate()
  const { state, handleFetch, handleReset, handleSelectAll, handleResetSelection } = useContext(WarehousesTableContext)

  const selection = useSelection(state.selectedRowIds)

  const goToCreate = useCallback(() => {
    navigate('/warehouses/create', { withBackground: true })
  }, [navigate])

  return { selection, handleFetch, handleResetSelection, handleSelectAll, handleReset, goToCreate }
}
